import { request } from "../../service/api";
import { ANNOUNCEMENT, DELETE_ANNOUNCEMENTS } from "../../constants";
import { constructEndpoint } from "../../utils/commonHelper";
import type { ApiEnvelope } from "../../types/api";
import type {
  AnnouncementDetail,
  CreateAnnouncementPayload,
  UpdateAnnouncementPayload,
} from "./types";

export function fetchAnnouncementById(
  id: number
): Promise<ApiEnvelope<AnnouncementDetail>> {
  return request(`${ANNOUNCEMENT}/${id}`, {
    method: "GET",
  }) as Promise<ApiEnvelope<AnnouncementDetail>>;
}

export function createAnnouncement(
  payload: CreateAnnouncementPayload
): Promise<ApiEnvelope<void>> {
  return request(ANNOUNCEMENT, {
    method: "POST",
    body: JSON.stringify(payload),
    skipToast: true,
  }) as Promise<ApiEnvelope<void>>;
}

export function updateAnnouncement(
  payload: UpdateAnnouncementPayload
): Promise<ApiEnvelope<void>> {
  return request(`${ANNOUNCEMENT}/${payload.id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    skipToast: true,
  }) as Promise<ApiEnvelope<void>>;
}

/**
 * Deletes multiple announcements in parallel using Promise.all.
 */
export function deleteAnnouncements(
  items: Array<{ id: number }>
): Promise<ApiEnvelope<void>[]> {
  return Promise.all(
    items.map(
      (item) =>
        request(constructEndpoint(DELETE_ANNOUNCEMENTS, item.id), {
          method: "DELETE",
        }) as Promise<ApiEnvelope<void>>
    )
  );
}
